// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"a10a3f92e9--wrapper--Wqqt1","title":"a10a3f92e9--title--K88Iu","buttons":"a10a3f92e9--buttons--jmCiX"};